import React, { ReactElement } from 'react';
import { Box, Stack, Divider, DividerProps, BoxProps } from '@chakra-ui/react';

interface CardProps extends BoxProps {
  header?: ReactElement;
  content?: ReactElement;
  footer?: ReactElement;
  width?: string;
  bg?: string;
  borderTopColor?: string;
}
export const Card: React.VFC<CardProps> = ({
  header,
  content,
  footer,
  width = '90%',
  bg = 'gray.200',
  height = 'auto',
  borderTopColor,
  ...props
}) => {
  return (
    <Box
      borderColor="gray.200"
      borderWidth="1px"
      borderRadius={8}
      width={width}
      borderTopWidth={borderTopColor ? '3px' : '1px'}
      borderTopColor={borderTopColor}
      {...props}
    >
      <Stack>
        {header && (
          <>
            <Stack backgroundColor={bg} py="2" px="2">
              {header}
            </Stack>
            <Divider m="0 !important" />
          </>
        )}
        <Stack px="2" py="2" minHeight="40px" justifyContent="center">
          {content}
        </Stack>
        {footer && (
          <>
            <Divider m="0 !important" />
            <Stack py="2" px="2">
              {footer}
            </Stack>
          </>
        )}
      </Stack>
    </Box>
  );
};
